import { withInstall } from '@vuemap/vue-amap-util'
import Image from './Image.vue'

export const ElAmapLayerImage = withInstall(Image)
export default ElAmapLayerImage
